import MessengerIcon from '../assets/messenger.svg';
import React, { useState, useEffect } from "react";

export default function FloatingMessenger() {
    const [showMessage, setShowMessage] = useState(false);
    const [hovered, setHovered] = useState(false);

    useEffect(() => {
        const showTimer = setTimeout(() => setShowMessage(true), 2000); // Show after 2 seconds
        const hideTimer = setTimeout(() => setShowMessage(false), 8000); // Hide after 6 seconds

        return () => {
            clearTimeout(showTimer);
            clearTimeout(hideTimer);
        };
    }, []);

    return (
        <div className="fixed bottom-6 right-6 z-50 flex items-center space-x-2">
            {/* Message box with animation */}
            <span
                className={`bg-black text-white px-6 py-3 rounded-md shadow-lg transition-transform duration-500 ${
                    showMessage || hovered 
                    ? "opacity-100 translate-x-0 flex transition-all duration-300" 
                    : "opacity-0 translate-x-10 hidden transition-all duration-300"
                }`}
            >
                Message Us
            </span>

            {/* Messenger button */}
            <a
                href="https://m.me/quilatonlawoffice"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-all flex items-center"
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
            >
                <img src={MessengerIcon} alt="Messenger Icon" width={32} height={32} />
            </a>
        </div>
    );
}
